import React, { useMemo } from "react";
import { Grid, Flex } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { ClientsGraphqlDataSource } from "./clientsGraphqlDataSource";
import { getColumnDefs } from "./columnDefs";
import { gridOptions as defaultGridOptions } from "./gridOptions";
import * as styles from "./styles_vanilla.css";

export const ClientsTable: React.FC = () => {
  const crltWorkflowEngine = useFeatureFlag("crltWorkflowEngine", false);
  const columnDefs = useMemo(() => getColumnDefs(crltWorkflowEngine), [crltWorkflowEngine]);

  const dataSource = useMemo(() => {
    return new ClientsGraphqlDataSource();
  }, []);

  const gridOptions = useMemo(
    () => ({
      ...defaultGridOptions,
      serverSideDatasource: dataSource,
    }),
    [dataSource],
  );

  return (
    <Flex className={styles.container} flexDirection="column">
      <Flex className={styles.gridWrapper}>
        <Grid
          columnDefs={columnDefs}
          gridOptions={gridOptions}
          suppressColumnVirtualisation={false}
          suppressRowVirtualisation={false}
        />
      </Flex>
    </Flex>
  );
};
